import { h, Host } from "@stencil/core";
import { debounce } from "../../utils/debounce";
import { throttle } from "../../utils/throttle";
import { getUniqueId } from "../../utils/unique-id";
export class SameHeightWrapper {
    constructor() {
        this.targetSelectors = null;
        this.itemContainerSelectors = null;
        this.sameHeightIdentifiers = [];
        this.elementsRects = [];
        this.itemContainerElements = undefined;
    }
    baseClass = "ux-same-height";
    heightAttribute = "data-same-height";
    element;
    setDataAttributeToTarget = () => {
        if (this.targetSelectors === null) {
            return;
        }
        const selectors = this.targetSelectors.split(";");
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < selectors.length; i++) {
            const elements = Array.from(this.element.querySelectorAll(selectors[i]));
            const uid = getUniqueId();
            // @ts-expect-error Check for typing
            elements.forEach((element) => {
                if (element.hasAttribute(this.heightAttribute)) {
                    return;
                }
                element.setAttribute(this.heightAttribute, uid);
            });
        }
    };
    setItemContaionerElements = () => {
        if (this.itemContainerSelectors !== null) {
            this.itemContainerElements = Array.from(this.element.querySelectorAll(`${this.itemContainerSelectors}`));
            return;
        }
        const targets = this.element.querySelectorAll(`*[${this.heightAttribute}]`);
        const range = new Range();
        range.setStartBefore(targets[0]);
        range.setEndAfter(targets[targets.length - 1]);
        this.itemContainerElements = Array.from(range.commonAncestorContainer.children);
    };
    getElementsRects() {
        const elementsRects = [];
        // @ts-expect-error Check for typing
        this.itemContainerElements.forEach((commonParent) => {
            const commonParentElement = commonParent;
            // do not include in the calculation items that have been hidden from the static filter;
            if (commonParentElement.classList.contains("ux-static-filter__item--hidden")) {
                return;
            }
            const commonParentRects = commonParent.getBoundingClientRect();
            let targetElementsRects = {};
            this.sameHeightIdentifiers.forEach((sameHeightIdentifier) => {
                // @ts-expect-error Check for typing
                const targetElement = commonParent.querySelector(`*[${this.heightAttribute}="${sameHeightIdentifier}"]`);
                if (targetElement !== null) {
                    const targetElementRects = targetElement.getBoundingClientRect();
                    targetElementsRects = {
                        ...targetElementsRects,
                        [sameHeightIdentifier]: {
                            targetElement,
                            targetElementRects
                        }
                    };
                }
            });
            elementsRects.push({
                commonParentElement,
                commonParentRects,
                targetElements: targetElementsRects,
                calculated: false
            });
        });
        this.elementsRects = elementsRects;
    }
    getSameHeightIdentifiers = () => {
        const sameHeightElements = this.element.querySelectorAll(`*[${this.heightAttribute}]`);
        const identifiers = [];
        // @ts-expect-error Check for typing
        sameHeightElements.forEach((element) => {
            // @ts-expect-error Check for typing
            identifiers.push(element.dataset.sameHeight);
        });
        const uniqueIdentifiers = [];
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < identifiers.length; i++) {
            if (!uniqueIdentifiers.includes(identifiers[i])) {
                uniqueIdentifiers.push(identifiers[i]);
            }
        }
        this.sameHeightIdentifiers = uniqueIdentifiers;
    };
    componentDidLoad() {
        this.setDataAttributeToTarget();
        this.getSameHeightIdentifiers();
        this.setItemContaionerElements();
        this.getElementsRects();
    }
    updateHeight() {
        this.updateElementsHeight();
    }
    updateElementsHeight = () => {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < this.elementsRects.length; i++) {
            const sameLineElements = this.elementsRects.filter((elementRects) => {
                return elementRects.commonParentRects.top === this.elementsRects[i].commonParentRects.top;
            });
            // eslint-disable-next-line @typescript-eslint/prefer-for-of
            for (let v = 0; v < this.sameHeightIdentifiers.length; v++) {
                let biggestHeight = 0;
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (let i = 0; i < sameLineElements.length; i++) {
                    const element = sameLineElements[i].targetElements[this.sameHeightIdentifiers[v]];
                    let height = 0;
                    if (element?.targetElementRects) {
                        this.preventVerticalMarginCollapse(element.targetElement);
                        height = element.targetElement.scrollHeight;
                    }
                    if (biggestHeight < height) {
                        biggestHeight = height;
                    }
                }
                sameLineElements.forEach((element) => {
                    const targetElement = element.targetElements[this.sameHeightIdentifiers[v]];
                    if (targetElement) {
                        targetElement.targetElement.style.minHeight = `${biggestHeight}px`;
                    }
                });
            }
        }
    };
    removeHeights = throttle(() => {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let v = 0; v < this.sameHeightIdentifiers.length; v++) {
            this.elementsRects.forEach((elementRects) => {
                const targetElement = elementRects.targetElements[this.sameHeightIdentifiers[v]];
                if (!targetElement) {
                    return;
                }
                targetElement.targetElement.style.minHeight = "auto";
            });
        }
    }, 400);
    getDebouncedRects = debounce(() => {
        this.getElementsRects();
    }, 400);
    async recalculateHeights() {
        this.removeHeights();
        this.getDebouncedRects();
    }
    preventVerticalMarginCollapse = (targetElement) => {
        const targetElementStyles = window.getComputedStyle(targetElement);
        const paddingTop = targetElementStyles.getPropertyValue("padding-top");
        const paddingBottom = targetElementStyles.getPropertyValue("padding-bottom");
        if (paddingTop === "0px") {
            targetElement.style.paddingTop = "0.05px";
        }
        if (paddingBottom === "0px") {
            targetElement.style.paddingBottom = "0.05px";
        }
    };
    render() {
        return (h(Host, { key: '028d9415b50825ebb00736f3c65f43e4f0a000ab', class: this.baseClass }, h("slot", { key: '6801cef8349c4c4596880e6582d1a66dbeb5255a' })));
    }
    static get is() { return "ux-same-height"; }
    static get properties() {
        return {
            "targetSelectors": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "optional: the css selectors for the elements that should have the same height, comma separated string"
                },
                "attribute": "target-selectors",
                "reflect": false,
                "defaultValue": "null"
            },
            "itemContainerSelectors": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "optional: the css selectors for the common parents to compare for the height calculations"
                },
                "attribute": "item-container-selectors",
                "reflect": false,
                "defaultValue": "null"
            }
        };
    }
    static get states() {
        return {
            "sameHeightIdentifiers": {},
            "elementsRects": {},
            "itemContainerElements": {}
        };
    }
    static get elementRef() { return "element"; }
    static get watchers() {
        return [{
                "propName": "elementsRects",
                "methodName": "updateHeight"
            }];
    }
    static get listeners() {
        return [{
                "name": "resize",
                "method": "recalculateHeights",
                "target": "window",
                "capture": false,
                "passive": true
            }];
    }
}
//# sourceMappingURL=same-height.js.map
